import { IStore, IAction } from "store";
import { IOpportunities } from "store/types";
import { DealAction } from "../../actions";
import { reducer } from "../index";

reducer.createHandler(
  DealAction.GetOpportunitiesSuccess,
  (state, { payload }: IAction<IOpportunities[]>): IStore => ({
    ...state,
    dealModule: {
      ...state.dealModule,
      opportunities: payload
    }
  })
);
